import Vue from "vue";
/* eslint-disable */

function getStyle(obj, attr) {
  if (obj.currentStyle) {
    return obj.currentStyle[attr];
  } else {
    return getComputedStyle(obj)[attr];
  }
}

function getLineHeight(el) {
  const lineHeight = getStyle(el, "line-height");
  if (lineHeight === "normal" || lineHeight === "") {
    const fontSize = parseInt(getStyle(el, "font-size"), 10) || 16;
    return fontSize * 1.2;
  }
  return parseInt(lineHeight, 10);
}

Vue.directive("overflow-tooltip", {
  inserted: function inserted(el, binding, vnode, oldVnode) {
    // 分步获取tooltip，避免undefined报错
    var rootVnode = vnode.context && vnode.context.$root && vnode.context.$root._vnode;
    var childVnode = rootVnode && rootVnode.child;
    var tooltip = childVnode && childVnode.$refs && childVnode.$refs.tooltip;

    if (!tooltip) {
      console.warn("未找到ref='tooltip'的el-tooltip组件");
      return;
    }

    // 存储tooltip到el上，方便后续访问
    el.__tooltipInstance__ = tooltip;
    const maxLine = binding.value || 1;

    // 基础样式（确保生效）
    el.style.whiteSpace = maxLine === 1 ? "nowrap !important" : "normal !important";
    el.style.wordBreak = maxLine === 1 ? "nowrap !important" : "break-all !important";
    el.style.overflow = "hidden !important";
    el.style.textOverflow = "ellipsis !important";
    el.style.display = "inline-block !important";
    el.style.verticalAlign = "middle";
    el.style.boxSizing = "border-box !important";
    // 关键：多行必须设置line-height（避免getLineHeight计算偏差）
    if (maxLine > 1 && !el.style.lineHeight) {
      el.style.lineHeight = getLineHeight(el) + "px !important";
    }

    // 鼠标移入事件（核心优化：多行溢出判断）
    el.__vueOverflowTooltipMouseenter__ = function() {
      const tooltip = el.__tooltipInstance__;
      if (!tooltip) return;

      let isOverflow = false;
      const hasContent = el.innerText.trim() || el.textContent.trim(); // trim()排除空内容

      if (!hasContent) {
        isOverflow = false; // 无内容直接不显示
      } else if (maxLine === 1) {
        // 单行判断逻辑不变（保持原有稳定性）
        isOverflow = el.scrollWidth > el.offsetWidth;
        if (!isOverflow && el.childNodes && el.childNodes.length) {
          try {
            const range = document.createRange();
            range.setStart(el, 0);
            range.setEnd(el, el.childNodes.length);
            const rangeWidth = Math.round(range.getBoundingClientRect().width)
            const paddingLeft = parseInt(getStyle(el, "paddingLeft"), 10) || 0;
            const paddingRight = parseInt(getStyle(el, "paddingRight"), 10) || 0;
            isOverflow = rangeWidth + paddingLeft + paddingRight > el.offsetWidth;
          } catch (e) {
            console.error("单行Range判断失败：", e);
          }
        }
      } else {
        // 【重点优化】多行溢出判断逻辑
        try {
          const lineHeight = getLineHeight(el);
          const paddingTop = parseInt(getStyle(el, "paddingTop"), 10) || 0;
          const paddingBottom = parseInt(getStyle(el, "paddingBottom"), 10) || 0;
          const verticalPadding = paddingTop + paddingBottom;

          // 1. 最大允许高度 = 行高 * 最大行数 + 上下内边距（原逻辑减内边距是错误的）
          const maxAllowedHeight = (lineHeight * maxLine) + verticalPadding;
          // 2. 实际内容高度 = el.scrollHeight（包含溢出部分，比range更准确）
          const actualContentHeight = el.scrollHeight;
          // 3. 容差阈值（2px，避免像素偏差导致的误判）
          const tolerance = 2;

          // 只有实际高度 > 最大允许高度 + 容差，才判定为溢出
          isOverflow = actualContentHeight > (maxAllowedHeight + tolerance);
        } catch (e) {
          console.error("多行高度判断失败：", e);
          isOverflow = false; // 异常时默认不显示
        }
      }

      if (isOverflow && hasContent) {
        // 原有修复逻辑保持不变
        if (tooltip.popperInstance) {
          tooltip.popperInstance.destroy();
          tooltip.popperInstance = null;
        }
        if (tooltip.$refs.popper && tooltip.$refs.popper.parentNode) {
          tooltip.$refs.popper.parentNode.removeChild(tooltip.$refs.popper);
          tooltip.$refs.popper = null;
        }

        tooltip.referenceElm = el;
        if (tooltip.$parent && tooltip.$parent.$data) {
          tooltip.$parent.$data.tooltipContent = hasContent;
        }

        tooltip.expectedState = false;
        tooltip.showPopper = false;

        setTimeout(() => {
          if (el.matches(':hover')) {
            tooltip.setExpectedState(true);
            tooltip.handleShowPopper();
            if (tooltip.popperInstance) {
              tooltip.popperInstance.update();
            }
          }
        }, 30);
      }
    };

    // 鼠标移出事件（保持原有优化）
    el.__vueOverflowTooltipMouseleave__ = function() {
      const tooltip = el.__tooltipInstance__;
      if (!tooltip) return;

      try {
        tooltip.setExpectedState(false);
        setTimeout(() => {
          if (tooltip.expectedState === false && !el.matches(':hover')) {
            tooltip.handleClosePopper();
            if (tooltip.popperInstance) {
              tooltip.popperInstance.destroy();
              tooltip.popperInstance = null;
            }
            if (tooltip.$refs.popper && tooltip.$refs.popper.parentNode) {
              tooltip.$refs.popper.parentNode.removeChild(tooltip.$refs.popper);
            }
          }
        }, 100);
      } catch (e) {
        console.error("关闭tooltip失败：", e);
      }
    };

    // 事件绑定防重复
    if (!el.__mouseenterBound__) {
      el.addEventListener("mouseenter", el.__vueOverflowTooltipMouseenter__, { passive: true });
      el.__mouseenterBound__ = true;
    }
    if (!el.__mouseleaveBound__) {
      el.addEventListener("mouseleave", el.__vueOverflowTooltipMouseleave__, { passive: true });
      el.__mouseleaveBound__ = true;
    }
  },

  componentUpdated: function componentUpdated(el, binding) {
    // 组件更新时重新应用样式和重置tooltip引用
    const maxLine = binding.value || 1;
    el.style.whiteSpace = maxLine === 1 ? "nowrap !important" : "normal !important";
    el.style.wordBreak = maxLine === 1 ? "nowrap !important" : "break-all !important";
    el.style.overflow = "hidden !important";
    el.style.textOverflow = "ellipsis !important";
    el.style.display = "inline-block !important";
    el.style.boxSizing = "border-box !important";
    // 多行补全line-height样式
    if (maxLine > 1 && !el.style.lineHeight) {
      el.style.lineHeight = getLineHeight(el) + "px !important";
    }

    // 重新获取tooltip，确保引用有效
    var rootVnode = el.__vue__ && el.__vue__.$vnode && el.__vue__.$vnode.context && el.__vue__.$vnode.context.$root && el.__vue__.$vnode.context.$root._vnode;
    var childVnode = rootVnode && rootVnode.child;
    var tooltip = childVnode && childVnode.$refs && childVnode.$refs.tooltip;
    if (tooltip) {
      el.__tooltipInstance__ = tooltip;
    }
  },

  unbind: function unbind(el) {
    // 保持原有清理逻辑
    if (el.__mouseenterBound__) {
      el.removeEventListener("mouseenter", el.__vueOverflowTooltipMouseenter__);
      el.__mouseenterBound__ = false;
    }
    if (el.__mouseleaveBound__) {
      el.removeEventListener("mouseleave", el.__vueOverflowTooltipMouseleave__);
      el.__mouseleaveBound__ = false;
    }

    const tooltip = el.__tooltipInstance__;
    if (tooltip) {
      tooltip.setExpectedState(false);
      tooltip.handleClosePopper();
      if (tooltip.popperInstance) {
        tooltip.popperInstance.destroy();
      }
      if (tooltip.$refs.popper && tooltip.$refs.popper.parentNode) {
        tooltip.$refs.popper.parentNode.removeChild(tooltip.$refs.popper);
      }
    }

    delete el.__vueOverflowTooltipMouseenter__;
    delete el.__vueOverflowTooltipMouseleave__;
    delete el.__tooltipInstance__;
    delete el.__mouseenterBound__;
    delete el.__mouseleaveBound__;
  }
});
